import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Kayit.css';

function Kayit() {
  const formLink = "https://docs.google.com/forms/d/e/1FAIpQLScONrpxe68j9_Ewugf-nf0lx6wEi6e3bpXlxUGdDwrNCqR-QA/viewform?pli=1";
  const mailAddress = "yonorg2026@gmail.com";

  return (
    <div className="kayit-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>KAYIT</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi Katılım Formu</p>
        </div>
      </header>

      <main className="content-container">
        {/* KRİTİK UYARI */}
        <div className="critical-alert">
          <i className="fas fa-exclamation-triangle"></i>
          <p>Kayıt formu doldurulmadan yapılan ödemeler geçersiz sayılacaktır.</p>
        </div>

        <div className="kayit-steps-grid">
          {/* ADIM 1: FORM DOLDURMA */}
          <section className="step-card">
            <div className="step-badge">1</div>
            <h3>Online Kayıt Formu</h3>
            <p>Aşağıdaki bağlantıya tıklayarak online kayıt formunu eksiksiz doldurunuz.</p>
            <a href={"https://docs.google.com/forms/d/1xdqsLom5yJDbARfct-soGvoDM9vuCRE0-lO5d5LC45U/viewform?edit_requested=true"} target="_blank" rel="noopener noreferrer" className="action-btn-link">
              KAYIT FORMUNA GİT <i className="fas fa-external-link-alt"></i>
            </a>
          </section>

               </div>

        <div className="kayit-info-footer">
          <p><strong>Son Kayıt Tarihi:</strong> 10 Mayıs 2026</p>
          <p>* Bildiri sahibi olan ve olmayan tüm katılımcıların kayıt yapması zorunludur.</p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Kayit;